import React from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteMessage = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const { oid, content } = props.data

  const handleOk = () => {
    axios.post('/p/content/message/delete', {
      merchant_oid: merchantOid,
      message_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('删除留言成功！')
          props.isCancel()
          props.getMessageData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal
      title="删除留言"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将留言
        <span style={{color: '#005dff'}}>《{content.length > 30 ? `${content.slice(0, 30)}...` : content}》</span>
        从列表中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteMessage
